<app-component-header></app-component-header>

<div class="component-block">
    <section class="block-formControlWrap">
        <div class="container">
            <div class="row">
                <div class="margin-bottom-5">
                    <div class="col-xs-6">
                        <div class="page-head">
                            <div class="page-title">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="block-formControl">
                        <div class="section-title-wrapper">
                            <span class="section-title">
                                Xác nhận email từ khách hàng
                            </span>
                        </div>
                        <div class="section">
                            <div class="text-center">
                                <img src="assets/img/email/email_checked.png" style="width:20%;" />
                                <h3>Xác nhận email đã hoàn tất.</h3>
                                <span>Trân trọng cảm ơn quý khách.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<app-component-footer></app-component-footer>